var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chatbot"}},[_c('a',{staticClass:"webim_button",attrs:{"href":"#","rel":"webim","title":_vm.$t(("" + (this.chat.label)), _vm.$i18n.locale)}},[_c('img',{attrs:{"src":_vm.url,"border":"0"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }